import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const PreviewPanel = ({ children, title, subtitle, caption, onViewAllClick, viewAllDisabled }) => {
  const { t } = useTranslation();

  return (
    <Paper variant="outlined" elevation={0}>
      <Box p={2}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            {subtitle && <Typography variant="h6">{subtitle}</Typography>}
            {title && <Typography variant="h5">{title}</Typography>}
          </Grid>
        </Grid>
      </Box>
      {caption && <Box px={2}><Typography variant='body1'>{caption}</Typography></Box>}
      {children}
      {onViewAllClick && (
        <Box py={2} px={2}>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" onClick={onViewAllClick} disabled={viewAllDisabled}>
                {t('View all')}
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </Paper>
  );
};

PreviewPanel.defaultProps = {
  children: null,
  title: null,
  subtitle: null,
  onViewAllClick: false,
  viewAllDisabled: false,
};

PreviewPanel.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onViewAllClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  viewAllDisabled: PropTypes.bool,
};

export default PreviewPanel;
